import { notification } from "antd";
import { FC, PropsWithChildren, useEffect, useState } from "react";

import { useFileProvider, useSdk, useLoc } from "@app/shared/lib/hooks";

import { LoadingOverlay } from "../ui";

export const SchoolProvider: FC<PropsWithChildren> = ({ children }) => {
  const sdk = useSdk();
  const loc = useLoc();
  const fileProvider = useFileProvider();

  const [ready, setReady] = useState(sdk.inited);

  useEffect(() => {
    if (sdk.inited) return;
    console.log('sdk.inited', sdk.inited);
    (async () => {
      await sdk.init();
      if (sdk.inited) {
        setReady(true);

        // sdk.school.update({
        //   community: new Community({
        //     enabled: true,
        //     popupText: "Welcome to the community! Here you can post, comment and communicate with participants.",
        //     popupJoinText: "Join",
        //     sortType: "createdDate",
        //     popularPostsWidgetEnabled: true,
        //     calendarWidgetEnabled: true,
        //     leaderboardWidgetEnabled: true,
        //     createdDate: moment(),
        //     updatedDate: moment(),
        //     id: "1",
        //   }),
        // });

        return;
      }

      notification.error({ message: loc.word("Error occured"), duration: 2 });
    })();
  }, []);

  // TODO: sdk.hub.school.supportChatEnabled

  if (!ready) return <LoadingOverlay position="absolute" />;

  return (
    <>
      <meta name="description" content={sdk.school.description} />
      <meta property="og:title" content={sdk.school.name} />
      {sdk.school.logo && (
        <meta
          property="og:image"
          content={fileProvider.getUrl(sdk.school.logo)}
        />
      )}
      {sdk.school.favicon ? (
        <link rel="icon" href={fileProvider.getUrl(sdk.school.favicon)!} />
      ) : (
        <link rel="icon" href="/favicon.png" />
      )}
      {children}
    </>
  );
};
